import { Loader } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const FullscreenLoader = () => {
  return (
    <div className={css.container}>
      <Loader />
    </div>
  );
};
